import { ca } from '@cian/analytics';

type TBestMortgageOffersTrapKind = 'banner' | 'modal';

const TRAP_TYPE_BY_KIND: Record<TBestMortgageOffersTrapKind, string> = {
  banner: 'banner_skidki_i_akcii_best_mortgage_offers',
  modal: 'modal_skidki_i_akcii_best_mortgage_offers',
};

const BANNER_TITLE = 'Лучшие ипотечные предложения';

/**
 * Показ баннера или модалки «Лучшие ипотечные предложения» на странице подборки /skidki-i-akcii/ipoteka/.../luchshie-predlozheniya/
 */
export function trackBestMortgageOffersTrapShow(params: {
  kind: TBestMortgageOffersTrapKind;
  bankName: string;
  bankProgram: string;
}) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_banner',
    page: {
      extra: {
        trap_type: TRAP_TYPE_BY_KIND[params.kind],
        bannerName: BANNER_TITLE,
        trapid: BANNER_TITLE,
        bank_name: params.bankName,
        bank_program: params.bankProgram,
      },
    },
  });
}

/**
 * Клик по кнопке «Заполнить заявку на Циане» в модалке на странице лучших ипотечных предложений
 */
export function trackBestMortgageOffersCianMortgageClick(params: { bankName: string; bankProgram: string }) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_banner',
    page: {
      extra: {
        trap_type: 'skidki_i_akcii_best_mortgage_offers',
        bannerName: BANNER_TITLE,
        trapid: BANNER_TITLE,
        bank_name: params.bankName,
        bank_program: params.bankProgram,
      },
    },
  });
}
